import { Component, Input } from '@angular/core';
import { CircleAlert, LucideAngularModule, Trash, X } from 'lucide-angular';
import { FormControl, FormGroup, FormsModule, Validators } from '@angular/forms';
import { ProductVariantOptionService } from '@app/products/shared/product-variant-option.service';
import { ProductVariantModel } from '@app/products/shared/product-variant.model';
import { ProductVariantOptionModel } from '@app/products/shared/product-variant-option.model';
import { TextInputComponent } from '@app/partials/form/text-input/text-input.component';
import { CurrencyPipe } from '@angular/common';

@Component({
  selector: 'app-product-variant-options',
  templateUrl: './product-variant-options.component.html',
  imports: [LucideAngularModule, FormsModule, TextInputComponent, CurrencyPipe],
})
export class ProductVariantOptionsComponent {
  @Input('item') protected variant?: ProductVariantModel;

  protected error?: string;

  protected optionForm = new FormGroup({
    name: new FormControl('', [Validators.required]),
    price: new FormControl<number | null>(null),
  });

  // Properly typed form controls for template binding
  protected nameControl = this.optionForm.controls.name;
  protected priceControl = this.optionForm.controls.price;

  constructor(private service: ProductVariantOptionService) {
    // console.log('ProductVariantOptionsComponent.constructor()');
  }

  protected readonly XIcon = X;

  remove(id: any) {
    this.service.delete(id).subscribe({
      next: () => {
        if (this.variant) {
          this.variant.options = this.variant.options.filter((option) => option.id !== id);
        }
      },
      error: (res) => {
        this.error = res.error.message;
      },
    });
  }

  addOption($event?: Event) {
    if ($event) {
      $event.stopPropagation();
    }
    if (this.optionForm.invalid) {
      this.optionForm.markAllAsTouched();
      return;
    }

    const priceValue = this.optionForm.get('price')?.value;
    // Convert string to number if using a mask
    const parsedPrice = priceValue ? parseFloat(priceValue.toString().replace(/,/g, '')) : null;

    // Validate price if entered
    if (parsedPrice !== null && parsedPrice < 0) {
      this.error = 'Price must be a positive number';
      return;
    }

    this.service
      .save({
        name: this.optionForm.get('name')?.value,
        product_variant_id: this.variant?.id,
        price: parsedPrice,
      } as ProductVariantOptionModel)
      .subscribe({
        next: (option) => {
          if (this.variant) {
            this.optionForm.reset();
            this.variant.options.push(option.data);
            this.error = undefined;
          }
        },
        error: (res) => {
          this.error = res.error.message;
        },
      });
  }

  protected readonly TrashIcon = Trash;
  protected readonly CircleAlert = CircleAlert;
}
